import * as types from 'store/modules/hrms74e/mutation-types'
import hrms74e from 'api/hrms74e'
import swal from 'sweetalert'
import hrms74eLabels from 'assets/labels/hrms74e'
import { constLabels } from 'assets/js/constLabels.js'
import { hrms74eColumns } from 'assets/columns/hrms74e'
import configLabel from 'src/../config/label'
import { sendApprove } from 'components/hrms74e/sendApproveHrms74e.js'

export default {
  state: {
    indexDisp: true,
    detailDisp: false,
    labels: hrms74eLabels,
    indexSearchParams: {},
    columns: hrms74eColumns(),
    index: {
      total: 0,
      rows: []
    },
    detail: {
      tab1: {},
      tab2: {
        total: 0,
        rows: []
      },
      tab3: {
        total: 0,
        rows: []
      }
    },
    indexSelected: [],
    indexInlineData: [],
    coursend: false
  },
  getters: {
    [types.GET_HRMS74E_INDEX_DISP] (state) {
      return state.indexDisp
    },
    [types.GET_HRMS74E_DETAIL_DISP] (state) {
      return state.detailDisp
    },
    [types.GET_HRMS74E_COLUMNS] (state) {
      return state.columns
    },
    [types.GET_HRMS74E_LABELS] (state) {
      return state.labels
    },
    [types.GET_HRMS74E_INDEX] (state) {
      return state.index
    },
    [types.GET_HRMS74E_INDEX_SEARCH_PARAMS] (state) {
      return state.indexSearchParams
    },
    [types.GET_HRMS74E_INDEX_SELECTED] (state) {
      return state.indexSelected
    },
    [types.GET_HRMS74E_DETAIL] (state) {
      return state.detail
    },
    [types.GET_HRMS74E_INDEX_INLINE_DATA] (state) {
      return state.indexInlineData
    },
    [types.GET_HRMS74E_COURSEND] (state) {
      return state.coursend
    }
  },
  mutations: {
    [types.SET_HRMS74E_INDEX_DISP] (state, indexDisp) {
      state.indexDisp = indexDisp
    },
    [types.SET_HRMS74E_DETAIL_DISP] (state, detailDisp) {
      state.detailDisp = detailDisp
    },
    [types.SET_HRMS74E_COLUMNS] (state, labels) {
      for (var keyLang of configLabel.allLang) {
        state.columns[keyLang].index = configLabel.replaceLabelToColumns(state.columns[keyLang].index, labels[keyLang])
        state.columns[keyLang].columnsTab2 = configLabel.replaceLabelToColumns(state.columns[keyLang].columnsTab2, labels[keyLang])
        state.columns[keyLang].columnsTab3 = configLabel.replaceLabelToColumns(state.columns[keyLang].columnsTab3, labels[keyLang])
      }
    },
    [types.SET_HRMS74E_LABELS] (state, labels) {
      state.labels.en = labels.en
      state.labels.th = labels.th
    },
    [types.SET_HRMS74E_INDEX] (state, data) {
      state.index = data
    },
    [types.SET_HRMS74E_INDEX_SEARCH_PARAMS] (state, data) {
      state.indexSearchParams = data
    },
    [types.SET_HRMS74E_INDEX_SELECTED] (state, indexSelected) {
      state.indexSelected = indexSelected
    },
    [types.SET_HRMS74E_DETAIL] (state, data) {
      state.detail = data
    },
    [types.SET_HRMS74E_INDEX_ADD_INLINE] (state, { data, param }) {
      let rowIndex = state.index.rows.map(function (dataRow) {
        return dataRow.codempid
      }).indexOf(param.codempid)
      state.index.rows[rowIndex].codempid = data.codempid
      state.index.rows[rowIndex].desc_codempid = data.desc_codempid
      state.index.rows[rowIndex].desc_codpos = data.desc_codpos
      state.index.rows[rowIndex].codcours = data.codcours
      state.index.rows[rowIndex].desc_codcours = data.desc_codcours
      state.index.rows[rowIndex].desc_codtparg = data.desc_codtparg
      state.index.rows[rowIndex].v_flgqlify = data.v_flgqlify
      state.index.rows[rowIndex].flgStaappr = ''
      state.index.rows[rowIndex].desc_staappr = data.desc_staappr
      state.index.rows[rowIndex].dteappr = data.dteappr
      state.index.rows[rowIndex].codappr = data.codappr
      state.index.rows[rowIndex].desc_codappr = data.desc_codappr
      state.index.rows[rowIndex].dteyear = data.dteyear
      state.index.rows[rowIndex].v_dtemonth = data.v_dtemonth
      state.index.rows[rowIndex].numclseq = data.numclseq
      state.index.rows[rowIndex].codcomp = data.codcomp
      state.index.rows[rowIndex].codpos = data.codpos
      state.index.rows[rowIndex].codplan = data.codplan
      state.index.rows[rowIndex].numlvl = data.numlvl
      state.index.rows[rowIndex].nummemo = data.nummemo
      state.index.rows[rowIndex].v_flgtrn = data.v_flgtrn
    },
    [types.SET_HRMS74E_INDEX_INLINE_DATA] (state, indexInlineData) {
      state.indexInlineData = indexInlineData
    }
  },
  actions: {
    [types.TOGGLE_HRMS74E_PAGE] ({ commit }, page) {
      let indexDisp = false
      let detailDisp = false
      switch (page) {
        case 'index':
          indexDisp = true
          break
        case 'detail':
          detailDisp = true
          break
      }
      commit(types.SET_HRMS74E_INDEX_DISP, indexDisp)
      commit(types.SET_HRMS74E_DETAIL_DISP, detailDisp)
    },
    [types.RECEIVED_HRMS74E_INDEX_ADD_INLINE] ({ commit }, { searchParams, param }) {
      hrms74e.getIndexAddInline({ searchParams, param })
        .then((response) => {
          const codempidData = JSON.parse(response.request.response)
          commit(types.SET_HRMS74E_INDEX_ADD_INLINE, { data: codempidData, param: param })
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRMS74E_COLUMNS_LABELS] ({ commit }) {
      hrms74e.getLabels()
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRMS74E_COLUMNS, data.labels)
          commit(types.SET_HRMS74E_LABELS, data.labels)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRMS74E_INDEX] ({ commit, state }, searchParams) {
      hrms74e.getIndex(searchParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          if (data.rows.length > 0) {
            if (data.rows[0].coursend === 'Y') {
              state.coursend = true
              swal({
                title: constLabels('warningTitle'),
                text: constLabels('HR1490'),
                html: true
              }, function () {
                window.onkeydown = null; window.onfocus = null; swal('')
              })
            } else {
              state.coursend = false
            }
          } else {
            state.coursend = false
          }
          // if (typeof data !== 'undefined' && typeof data.rows !== 'undefined' && typeof data.rows[0] !== 'undefined') {
          //   searchParams.nummemo = typeof data.rows[0].nummemo !== 'undefined' ? data.rows[0].nummemo : searchParams.nummemo
          //   searchParams.codcours = typeof data.rows[0].codcours !== 'undefined' ? data.rows[0].codcours : searchParams.codcours
          //   searchParams.year = typeof data.rows[0].dteyear !== 'undefined' ? data.rows[0].dteyear : searchParams.year
          //   searchParams.numclseq = typeof data.rows[0].numclseq !== 'undefined' ? data.rows[0].numclseq : searchParams.numclseq
          // }
          commit(types.SET_HRMS74E_INDEX_SEARCH_PARAMS, searchParams)
          commit(types.SET_HRMS74E_INDEX, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
          let objData = {
            total: 0,
            rows: []
          }
          commit(types.SET_HRMS74E_INDEX_SEARCH_PARAMS, searchParams)
          commit(types.SET_HRMS74E_INDEX, objData)
        })
    },
    [types.RECEIVED_HRMS74E_DETAIL] ({ commit }, searchParams) {
      hrms74e.getDetail(searchParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRMS74E_DETAIL, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.POST_HRMS74E_SEND_APPROVE] ({ commit, dispatch }, { searchIndex, dataRows, codappr }) {
      sendApprove({
        params: {
          searchIndex: searchIndex,
          dataRows: dataRows,
          codappr: codappr
        },
        sendApprove: hrms74e.postSendApprove,
        dispatch: dispatch,
        dispatchType: types.RECEIVED_HRMS74E_INDEX
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/hrms74e/index.js